import React, { useEffect } from 'react';
import { Modal, Form, Input, Button, message } from 'antd';
import { doc, updateDoc } from "firebase/firestore";
import { db } from '../../../firebaseConfig';
import './ItemModal.less';

const { TextArea } = Input;

const EditItemModal = ({ isVisible, onClose, fetchItems, editingItem, setEditingItem }: any) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (editingItem) {
            form.setFieldsValue({
                nameEn: editingItem.name.en,
                nameZh: editingItem.name.zh,
                shortDescEn: editingItem.shortDesc.en,
                shortDescZh: editingItem.shortDesc.zh,
                longDescEn: editingItem.longDesc.en,
                longDescZh: editingItem.longDesc.zh,
                price: editingItem.price,
                beforeDiscountPrice: editingItem.beforeDiscountPrice
            });
        }
    }, [editingItem, form]);

    const handleEditItem = async () => {
        try {
            const values = form.getFieldsValue();
            const itemDoc = doc(db, "items", editingItem.id);
    
            await updateDoc(itemDoc, {
                name: { en: values.nameEn, 'zh-CN': values.nameZh },
                shortDesc: { en: values.shortDescEn, 'zh-CN': values.shortDescZh },
                longDesc: { en: values.longDescEn, 'zh-CN': values.longDescZh },
                price: values.price,
                beforeDiscountPrice: values.beforeDiscountPrice,
            });
    
            setEditingItem(null);
            onClose();
            fetchItems();
            message.success("Item updated successfully!");
        } catch (error) {
            console.error("Error updating document: ", error);
            message.error("Error updating item!");
        }
    };
    return (
        <Modal
            title="Edit Item"
            open={isVisible}
            onCancel={() => {
                setEditingItem(null);
                form.resetFields();
                onClose();
            }}
            footer={null}
        >
            <Form form={form} onFinish={handleEditItem} layout="vertical">
                {/* Name Fields */}
                <Form.Item
                    label="Name (EN)"
                    name="nameEn"
                    rules={[{ required: true, message: 'Please input the English name!' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Name (ZH)"
                    name="nameZh"
                    rules={[{ required: true, message: 'Please input the Chinese name!' }]}
                >
                    <Input />
                </Form.Item>

                {/* Short Description Fields */}
                <Form.Item
                    label="Short Description (EN)"
                    name="shortDescEn"
                    rules={[{ required: true, message: 'Please input the English short description!' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Short Description (ZH)"
                    name="shortDescZh"
                    rules={[{ required: true, message: 'Please input the Chinese short description!' }]}
                >
                    <Input />
                </Form.Item>

                {/* Long Description Fields */}
                <Form.Item
                    label="Long Description (EN)"
                    name="longDescEn"
                    rules={[{ required: true, message: 'Please input the English long description!' }]}
                >
                    <TextArea rows={4} />
                </Form.Item>
                <Form.Item
                    label="Long Description (ZH)"
                    name="longDescZh"
                    rules={[{ required: true, message: 'Please input the Chinese long description!' }]}
                >
                    <TextArea rows={4} />
                </Form.Item>

                {/* Price Field */}
                <Form.Item
                    label="Price"
                    name="price"
                    rules={[{ required: true, message: 'Please input the price!' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item label="Before Discount Price" name="beforeDiscountPrice">
                    <Input />
                </Form.Item>

                <Form.Item>
                    <div className="modal-buttons">
                        <Button
                            onClick={() => {
                                setEditingItem(null);
                                form.resetFields();
                                onClose();
                            }}
                        >
                            Cancel
                        </Button>
                        <Button type="primary" htmlType="submit">
                            Save Changes
                        </Button>
                    </div>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default EditItemModal;
